import React, { useState } from "react";
import { Close } from "@mui/icons-material";
import Slider from "react-slick";
import bg1 from "../assets/ss1.png";
import bg2 from "../assets/ss2.png";
import bg4 from "../assets/ss3.png";
import bg5 from "../assets/ss4.png";
import bg6 from "../assets/ss5.png";
import "./Social.scss";
import { Dialog, IconButton } from "@mui/material";

const pictures = [
  { img: bg2, text: "Social" },
  { img: bg4, text: "Social" },
];

const cardData1 = [
  {
    img: bg6,
    text: "Wall Street Feeds",
    url: "https://www.wsj.com/news/realestate",
  },
  {
    img: bg5,
    text: "Construction Dive",
    url: "https://www.constructiondive.com",
  },
  {
    img: bg4,
    text: "Realtor Feeds",
    url: "https://www.housingwire.com/real-estate/",
  },
];

const carouselSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  fade: true,
  cssEase: "ease",
};


function Social(props: any): React.ReactElement {
  const [open, setOpen] = useState(false);
  const [currentUrl, setCurrentUrl]: any = useState("");

  const handlePopup = (url: string) => {
    url && setCurrentUrl(url);
    setOpen(true);
  };

  const handleClose = () => {
    setCurrentUrl("");
    setOpen(false);
  };

  return (
    <div className="social-main">
      <div className="social-main__imgContainer">
        <Slider {...carouselSettings}>
          {pictures?.map((item: any, index: any) => (
            <div key={index} className="social-main__imgContainer__innerDiv">
              <div
                className={"social-main__imgContainer__innerDiv__imageBg"}
                style={{ backgroundImage: `url(${item?.img})` }}
              >
                <div
                  className={
                    "social-main__imgContainer__innerDiv__imageBg__text"
                  }
                >
                  {item?.text}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <div className="social-main__content">
        <div className="social-main__content__cardContainer">
          {cardData1?.map((item: any, i: number) => (
            <div
              key={i}
              className="social-main__content__cardContainer__card1"
              style={{
                margin: i === 1 ? "0 100px" : 0,
              }}
              onClick={() => handlePopup(item?.url)}
            >
              <div
                className="social-main__content__cardContainer__card1__imgDiv"
                style={{
                  backgroundImage: `url(${item?.img})`,
                }}
              ></div>
              <div className="social-main__content__cardContainer__card1__textContainer">
                <span className="social-main__content__cardContainer__card1__textContainer__text">
                  {cardData1[i].text}
                </span>
              </div>
            </div>
          ))}
        </div>
        <div className={"social-main__content__cardContainer"}>
          <div className="social-main__content__cardContainer__card2">
            <div
              className="social-main__content__cardContainer__card2__imgDiv"
              style={{
                backgroundImage: `url(${bg6})`,
              }}
            ></div>
            <div className="social-main__content__cardContainer__card2__textContainer">
              <span className="social-main__content__cardContainer__card2__textContainer__text">
                {cardData1[0].text}
              </span>
            </div>
          </div>
          <div className="social-main__content__cardContainer__card3">
            <div
              className="social-main__content__cardContainer__card3__imgDiv"
              style={{
                backgroundImage: `url(${bg1})`,
              }}
            >
              <div className="social-main__content__cardContainer__card3__text">
                {cardData1[0].text}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog
          PaperProps={{
            sx: {
              maxHeight: "95%",
              minHeight: "95%",
              minWidth: "95%",
              maxWidth: "95%",
              overflow: "hidden",
              background: "#fff !important",
            }
          }}
          open={open}>
        <IconButton className="social-main__closeBtn" onClick={handleClose}>
          <Close className="social-main__closeBtn__icon" />
        </IconButton>
        <div className="social-main__iframeContainer">
          {currentUrl ? (
            <>
              <iframe
                className="social-main__iframeContainer__iframe"
                src={currentUrl}
              />
              <div className="social-main__iframeContainer__loader">
                Loading...
              </div>
            </>
          ) : (
            "No Url found"
          )}
        </div>
      </Dialog>
    </div>
  );
}

export default Social;
